// Versandwahl bei Vorbestellung (25.10.2026).
// Markup: snippets/rxk-versand-wahl.liquid, Lage: snippets/rxk-versand-lage.liquid
//
// Haelt den Warenkorb passend zur Wahl:
// - Eigenschaft "Versand" (deutsch, fuer Werkstatt und Billbee)
// - Gebuehrzeile "zweite-sendung": genau 1x in der passenden Variante bei
//   getrennt (std/exp), sonst keine
// Nach einer Aenderung laedt die Seite neu, damit Summen, Hinweise und
// Kassenknoepfe aus Liquid stimmen.
//
// Eigene Datei im Layout statt <script> im Snippet, wie beim
// Bearbeitungshinweis: Die Schublade setzt ihren Inhalt per innerHTML ein.
if (!customElements.get('rxk-versand-wahl')) {
  customElements.define(
    'rxk-versand-wahl',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (e) => {
          if (e.target.name === 'rxk-versand') this.abgleichen(e.target.value);
        });
        this.abgleichen(this.dataset.wahl);
      }

      async abgleichen(wahl) {
        const d = this.dataset;
        const texte = { zusammen: d.textZusammen, std: d.textStd, exp: d.textExp };
        const attr = texte[wahl] || '';
        const variante = wahl === 'std' ? d.vStd : wahl === 'exp' ? d.vExp : '';
        const hatZeile = Boolean(d.zweitKey);
        const zeileRichtig = hatZeile && d.zweitVariante === variante && d.zweitMenge === '1';

        const updates = {};
        let hinzu = false;
        if (variante) {
          if (!zeileRichtig) {
            if (hatZeile) updates[d.zweitKey] = 0;
            hinzu = true;
          }
        } else if (hatZeile) {
          updates[d.zweitKey] = 0;
        }
        if ((d.attr || '') === attr && !hinzu && !Object.keys(updates).length) return;

        // Schutz gegen eine Neulade-Schleife, falls Shopify etwas anders
        // speichert als erwartet.
        const merker = 'rxk-versand-wahl';
        const jetzt = Date.now();
        let laeufe = [];
        try {
          laeufe = JSON.parse(sessionStorage.getItem(merker) || '[]').filter((t) => jetzt - t < 30000);
        } catch (e) {}
        if (laeufe.length >= 4) return;
        try {
          sessionStorage.setItem(merker, JSON.stringify([...laeufe, jetzt]));
        } catch (e) {}

        this.setAttribute('aria-busy', 'true');
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const senden = (pfad, daten) =>
          fetch(root + pfad, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(daten),
          });
        try {
          await senden('cart/update.js', { attributes: { Versand: attr }, updates });
          if (hinzu) await senden('cart/add.js', { items: [{ id: Number(variante), quantity: 1 }] });
        } finally {
          location.reload();
        }
      }
    }
  );
}
